import type { SelectEmployeeListItem } from '../views/SelectEmployeeList.types';
import InfoDrawer from './InfoDrawer';

/** The presentation text itself, without chrome, so a host view can render it in place. */
export const EmployeeInfoContent = ({ employee }: { employee: SelectEmployeeListItem }) => (
  <div className="gap-xs flex flex-col">
    {employee.jobTitle && <span className="text-s text-fg_secondary font-bold">{employee.jobTitle}</span>}
    <p className="text-m text-fg_secondary whitespace-pre-line">{employee.info}</p>
  </div>
);

/**
 * The employee's presentation text (`about.info`), opened from a card's (i) button.
 * Wears the shared InfoDrawer chrome so it reads as the same surface as the service (i).
 */
const EmployeeInfoModal = ({
  employee,
  onClose,
}: {
  employee: SelectEmployeeListItem | undefined;
  onClose: () => void;
}) => {
  // Unmounted rather than kept at isOpen={false}, so no modal is mounted for every list.
  if (!employee) return null;

  return (
    <InfoDrawer isOpen onClose={onClose} title={employee.name}>
      <EmployeeInfoContent employee={employee} />
    </InfoDrawer>
  );
};

export default EmployeeInfoModal;
